import { OWNER_TYPES } from "@/static/ownerTypes";
import { Expose } from "class-transformer";
import { IsNumber, IsString } from "class-validator";

export class OrderGetTemporaryOwner {
  @IsNumber()
  @Expose()
  id!: number;
  @IsNumber()
  @Expose()
  share!: number;
  @Expose()
  ownerType!: OWNER_TYPES;
  @IsString()
  @Expose()
  name!: string;
}

export type OrderGetTemporaryOwnersResponse = Array<OrderGetTemporaryOwner>;
